module.exports = __webpack_public_path__ + "img/3_53.20a69a6e.png";